import React, { useState } from 'react'
import buyerRoutes from '../../common/buyerRoutes';
import { withRouter } from 'react-router';
import './TopNavigationBar.less';
import businessProActive from '../../assets/images/newui/navbar/business-pro-active.svg'
import businessPro from '../../assets/images/newui/navbar/business-pro.svg'
import Config from 'Config'
import { connect } from 'react-redux';


const TopNavigationBar = ({ history, currentUser, showActiveRequests }) => {
    const [hoveredElem, setHoveredElem] = useState({});
    const businessProfileNav = {
        name: "Business Profile",
        img: businessPro,
        activeImg: businessProActive,
    }

    let tabs = buyerRoutes;
    if(showActiveRequests == false){
        tabs = _.filter(tabs, t => t.name != 'Open Requests')
    }
    tabs = tabs.filter(br => br.img);
    const activeTab = tabs.find(tab => tab.path && tab.path.includes(history.location.pathname.split('/')[1])) || {}
    const onClick = (tab) => {
        const { state, city, seoName } = currentUser.Seller;
        if (tab.name == "Business Profile") {
            window.open(`${Config.badr.url}/business/${state}/${city}/${seoName}`, "_blank");
            return;
        }
        history.push(tab.path);
    }
    if (currentUser.Seller.isProfilePublished) {
        tabs = [...tabs, businessProfileNav]
    }
    return <div className='top-nav-bar-container' style={{ width: `${134 * tabs.length}px` }}>
        {tabs.map(tab => <div
            onMouseOver={() => setHoveredElem(tab)}
            onMouseOut={() => setHoveredElem({})}
            onClick={() => onClick(tab)}
            className={`top-nav-bar-tab${activeTab.name == tab.name || hoveredElem.name == tab.name ? ' active' : ''}`}>

            <img src={activeTab.name == tab.name || hoveredElem.name == tab.name ? tab.activeImg : tab.img} />
            <div className='top-nav-bar-tab-content'> {tab.name}</div>
        </div>)}
    </div>

}
const mapStateToProps = ({
    auth: { currentUser },
}) => {
    return { currentUser };
}

export default withRouter(connect(mapStateToProps, null)(TopNavigationBar));